import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { getNameAndType, getTemplateList, changeTemplateStatus, addFileTemplate, editFileTemplate, getFileTemplateDetail } from './request.js';
import functionalConfigurationModal from './functionalConfigurationModal.vue';
import { uploadFile } from './../../customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
export default {
  components: {
    functionalConfigurationModal
  },
  data() {
    return {
      form: {},
      action: uploadFile,
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'id',
        key: '1',
        align: 'center',
        width: 80
      }, {
        slots: {
          title: '文件类型'
        },
        dataIndex: 'type',
        key: '2',
        align: 'center',
        ellipsis: true,
        scopedSlots: {
          customRender: 'fileType'
        }
      }, {
        slots: {
          title: '文件名称'
        },
        dataIndex: 'name',
        key: '3',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '版本号'
        },
        dataIndex: 'version',
        key: '4',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '5',
        align: 'center',
        ellipsis: true,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: '6',
        align: 'center',
        ellipsis: true
      }, {
        slots: {
          title: '操作'
        },
        key: '7',
        align: 'center',
        width: 230,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      fileSortOptions: [{
        label: '投保单',
        value: 0
      }, {
        label: '保单',
        value: 2
      }, {
        label: '批单',
        value: 3
      }],
      typeOptions: [],
      visible: false,
      customerInfo: [],
      fileVisible: false,
      fileForm: {
        name: undefined,
        type: undefined,
        version: undefined
      },
      fileList: [],
      editRecord: null,
      functionalVisible: false,
      nameOptions: []
    };
  },
  computed: {
    ruleData() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('模板名称'),
          trigger: 'blur'
        }],
        version: [{
          required: true,
          message: this.$t('请输入') + this.$t('版本号'),
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('文件类型'),
          trigger: 'change'
        }],
        url: [{
          required: true,
          type: 'array',
          validator: this.validateFile,
          trigger: 'change'
        }]
      };
    }
  },
  created() {
    getNameAndType({}).then(res => {
      if (res) {
        this.nameOptions = res.name;
        let typeObjectKeys = Object.keys(res.type);
        for (let i = 0; i < typeObjectKeys.length; i++) {
          this.typeOptions.push({
            value: typeObjectKeys[i],
            label: res.type[typeObjectKeys[i]]
          });
        }
      }
    });
    this.getFileTemplateTable();
  },
  methods: {
    toFunactionalConfiguration() {
      this.functionalVisible = true;
    },
    editFileTemplate(record) {
      this.fileVisible = true;
      this.$refs.fileForm && this.$refs.fileForm.resetFields();
      this.editRecord = record;
      getFileTemplateDetail({
        id: record.id
      }).then(res => {
        if (res) {
          var _res$url;
          this.fileForm = {
            name: res.name,
            type: res.type,
            version: res.version
          };
          let arr = (_res$url = res.url) === null || _res$url === void 0 ? void 0 : _res$url.split('.');
          let suffix = arr.pop();
          this.fileList = [{
            uid: '1',
            status: 'done',
            url: res.url,
            name: res.name + '.' + suffix
            //   type: 'docx'
          }];
        }
      });
    },
    validateFile(rule, value, callback) {
      if (this.fileList.length == 0) {
        callback(new Error(this.$t('请上传文件模板')));
      } else {
        callback();
      }
    },
    handleChange(info) {
      var _info$file;
      if (info.file.status === 'done') {
        if (info.file.response.code != 200) {
          this.$message.destroy();
          this.$message.error(info.file.response.message);
          this.fileList[this.fileList.length - 1].status = 'error';
        }
      }
      const wordReg = /(docx|doc)$/;
      const filename = (info === null || info === void 0 || (_info$file = info.file) === null || _info$file === void 0 ? void 0 : _info$file.name) || '';
      const imgSuffix = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
      const isWord = wordReg.test(imgSuffix);
      if (!isWord) {
        this.$message.destroy();
        this.$message.error(this.$t('文件类型错误'));
        return;
      }
      let fileList = info.fileList;
      this.fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
    },
    onPreview(val) {
      const url = 'https://view.officeapps.live.com/op/view.aspx?src=' + val.url;
      window.open(url);
    },
    newFileTemplateOk() {
      this.$refs['fileForm'].validate(valid => {
        if (valid) {
          let params = {
            name: this.fileForm.name,
            type: this.fileForm.type,
            version: this.fileForm.version
          };
          if (this.fileList.length > 0) {
            params.url = this.fileList[0].url || '';
          }
          if (this.editRecord && this.editRecord.id) {
            params.id = this.editRecord.id;
            editFileTemplate(params).then(res => {
              if (res.id) {
                this.$refs.fileForm.resetFields();
                this.$message.success(this.$t('修改成功'));
                this.fileList = [];
                this.editRecord = null;
                this.fileVisible = false;
                this.getFileTemplateTable();
              }
            });
          } else {
            addFileTemplate(params).then(res => {
              if (res.id) {
                this.$refs.fileForm.resetFields();
                this.$message.success(this.$t('新增成功'));
                this.fileVisible = false;
                this.getFileTemplateTable();
              }
            });
          }
        }
      });
    },
    newUploadTemplate() {
      this.fileVisible = true;
      this.fileList = [];
      this.editRecord = null;
      this.$refs.fileForm && this.$refs.fileForm.resetFields();
    },
    searchFileTemplate() {
      this.pagination.current = 1;
      this.getFileTemplateTable();
    },
    getFileTemplateTable() {
      let params = {
        type: this.form.type || '',
        name: this.form.name || '',
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      getTemplateList(params).then(res => {
        if (res && res.items) {
          this.pagination.total = res.totalNum;
          this.data = res.items;
        }
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getFileTemplateTable();
    },
    changeStatus(record) {
      let params = {
        id: record.id,
        status: record.status === 1 ? 0 : 1
      };
      this.quetoFileList = [];
      changeTemplateStatus(params).then(res => {
        if (!res.id) {
          this.visible = true;
          this.customerInfo = res;
        } else {
          this.$message.destroy();
          this.$message.success(this.$t('修改成功'));
          this.data.forEach(item => {
            if (item.id === record.id) {
              item.status = item.status === 1 ? 0 : 1;
            }
          });
        }
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    async handlePreview(file) {
      const url = 'https://view.officeapps.live.com/op/view.aspx?src=' + file.url;
      window.open(url);
    }
  }
};